import React, { useState } from "react";
import { useArticle } from "../../../../Contexts/ArticleContext";
import style from "./SearchBar.module.css";

const SearchBar = ({ handleClick }) => {
  const [query, setQuery] = useState("");
  const [articles, setArticles] = useArticle();
  const [disabled, setDisabled] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    const news_url = `https://free-news.p.rapidapi.com/v1/search?q=${query.toLowerCase()}&lang=en&country=IN&topic=news&page_size=20`;
    const config = {
      method: "GET",
      headers: {
        "x-rapidapi-key": process.env.REACT_APP_X_RAPIDAPI_KEY,
        "x-rapidapi-host": process.env.REACT_APP_X_RAPIDAPI_HOST,
      },
    };

    try {
      const response = await fetch(news_url, config);
      const data = await response.json();
      const finalArticles = data.articles.map((article) => {
        return {
          url: article.link,
          urlToImage: article.media,
          publishedAt: article.published_date,
          source: {
            name: article.author,
          },
          title: article.title,
          description: article.summary
            ? article.summary.slice(0, 300) + "...."
            : "",
        };
      });
      setQuery("");
      setArticles(finalArticles);
    } catch (err) {
      console.log(err);
    }
    setDisabled(false);
  };

  return (
    <div className={style.searchBar}>
      <h1>Get Latest News Headlines in a Smarter Way</h1>

      <form onSubmit={handleSubmit} className={style.searchForm}>
        <div className={style.formGroup}>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search News Headlines"
            required
          />
        </div>
        <div className={style.formGroup} id="buttons">
          <button className={style.searchButton} disabled={disabled}>
            Search
          </button>
          <button className={style.commandButton} onClick={handleClick}>
            Command Guide
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
